module.exports = __webpack_public_path__ + "img/img-5.cc2f4c2c.png";